(() => {
  const marker = 'Altgeräterücknahme gewünscht';
  let pending = Promise.resolve();
  let updating = false;
  let queued = 0;
  const buttonStates = new Map();
  const lock = () => {
    updating = true;
    document.querySelectorAll('[name="checkout"]').forEach(button => {
      if (!buttonStates.has(button)) buttonStates.set(button, button.disabled);
      button.disabled = true;
    });
  };
  const root = window.Shopify?.routes?.root || '/';
  const update = (checked) => {
    queued++;
    lock();
    pending = pending.catch(() => {}).then(async () => {
      lock();
      try {
        const cartResponse = await fetch(root + 'cart.js');
        if (!cartResponse.ok) throw new Error('Cart unavailable');
        const cart = await cartResponse.json();
        const lines = (cart.note || '').split('\n').filter(line => line.trim() !== marker);
        if (checked) lines.push(marker);
        const note = lines.join('\n').trim();
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({note, attributes: {'Altgeräterücknahme': checked ? 'Ja' : ''}})
        });
        if (!response.ok) throw new Error('Save failed');
        document.querySelectorAll('[name="note"]').forEach(field => { field.value = note; });
        document.querySelectorAll('[data-appliance-return]').forEach(field => { field.checked = checked; });
        document.querySelectorAll('[data-appliance-return-error]').forEach(field => { field.hidden = true; });
      } catch (error) {
        document.querySelectorAll('[data-appliance-return-error]').forEach(field => { field.hidden = false; });
        document.querySelectorAll('[data-appliance-return]').forEach(field => { field.checked = !checked; });
        throw error;
      } finally {
        queued--;
        if (!queued) {
          updating = false;
          buttonStates.forEach((disabled, button) => { button.disabled = disabled; });
          buttonStates.clear();
        }
      }
    });
    return pending;
  };
  document.addEventListener('change', event => {
    if (event.target.matches('[data-appliance-return]')) update(event.target.checked).catch(() => {});
  });
  document.addEventListener('submit', event => {
    if (updating && event.submitter?.name === 'checkout') event.preventDefault();
  }, true);
  let cleanupScheduled = false;
  const cleanup = () => {
    if (cleanupScheduled) return;
    const states = [...document.querySelectorAll('[data-appliance-return-eligible]')];
    if (!states.length || states.some(state => state.dataset.applianceReturnEligible === 'true')) return;
    cleanupScheduled = true;
    fetch(root + 'cart.js').then(response => response.json()).then(cart => {
      if (cart.attributes?.['Altgeräterücknahme'] === 'Ja' || (cart.note || '').split('\n').some(line => line.trim() === marker)) return update(false);
    }).catch(() => {}).finally(() => { cleanupScheduled = false; });
  };
  document.addEventListener('DOMContentLoaded', cleanup);
  new MutationObserver(cleanup).observe(document.documentElement, {childList:true, subtree:true});
})();